// src/prompts/templates/generateConversationTitle.ts
var generateConversationTitlePrompt = [
  "You title AI assistant conversations.",
  "Given the first message a user sent to the assistant, write a short, descriptive title that captures the topic or intent.",
  "Keep it 2-6 words, in title case, with no surrounding quotes and no trailing punctuation.",
  'Respond with ONLY valid JSON in this exact format: {"title": "..."}'
].join("\n");

export {
  generateConversationTitlePrompt
};
